import { useState, useMemo } from 'react';

export interface SearchActions {
    setOverlayIsShown: (show: boolean) => void;
}

export interface SubscriptionSearchState {
    overlayIsShown: boolean;
    actions: SearchActions;
}

export default function useLoadersState(): SubscriptionSearchState {
    const [overlayIsShown, setOverlayIsShown] = useState<boolean>(false);

    const actions: SearchActions = useMemo(
        () => ({
            setOverlayIsShown,
        }),
        [],
    );

    return useMemo(
        () => ({
            overlayIsShown,
            actions,
        }),
        [overlayIsShown, actions],
    );
}
